import WidgetTimeUpdate from 'components/Widgets/WidgetTimeUpdate';
import 'leaflet/dist/leaflet.css';
import {
  DOPPLER_ACCESSIBLE_NAME,
  DOPPLER_CONFIG,
  DOPPLER_ROUTE,
} from '../../config/dopplerRadar.config.js';
import DopplerMapContent from '../DopplerMapContent/DopplerMapContent.jsx';

const DopplerRadarContent = ({
  accessibleName = DOPPLER_ACCESSIBLE_NAME,
  compact = false,
  scrollZoom = true,
  useSinglePanelCompactControls = false,
}) => (
  <section
    aria-label={accessibleName}
    className="doppler-radar h-100 w-100 d-flex flex-column user-select-none overflow-hidden min-h-0"
  >
    <WidgetTimeUpdate
      route={DOPPLER_ROUTE}
      updateIntervalBasis={DOPPLER_CONFIG.frameIntervalMinutes}
      addMargin={!compact}
      compact={compact}
      className="text-light"
    />
    <div className="position-relative flex-fill w-100 min-h-0">
      <DopplerMapContent
        compact={compact}
        scrollZoom={scrollZoom}
        useSinglePanelCompactControls={useSinglePanelCompactControls}
      />
    </div>
  </section>
);

export default DopplerRadarContent;
